import React, { useEffect, useState } from "react";
import { Form, Input, Modal } from "antd";
import { useAppDispatch, useAppSelector } from "../../modal/hooks";
import { questionTypeAndWeightageCreate, updateQueTypeAndWeightage } from "../../services/settings/settings.service";
import { stateType } from ".";
import {
	clearCreateTypeAndWeightageQuestion,
	clearUpdateQueTypeAndWeightage,
} from "../../services/settings/settings.slice";
import "./settings.scss";

type ComponentType = {
	modalType: string;
	onClose: () => void;
	state: stateType;
};

export interface createQuestionTypeAndWeightageType {
	id?: number;
	name: string;
	weightage: number;
}
export interface updateQuestionTypeAndWeightageType {
	id?: number;
	obj: { name: string; weightage: number };
}
export const AddNewQuestiontypeWeightage = (props: ComponentType) => {
	const typeAndWeightage = useAppSelector((store) => store.settings.queTypeAndWeightage);

	const [weightage, setWeightage] = useState("");

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		const value: string = e.target.value;
		if (/^\d{0,10}$/.test(value)) {
			setWeightage(value);
		}
	};

	const dispatch = useAppDispatch();
	const handleOk = async () => {
		switch (props.modalType) {
		case "add":
			try {
				dispatch(clearCreateTypeAndWeightageQuestion());
				const values = await form.validateFields();
				const duplicateType = typeAndWeightage.some(
					(item) => item.name.toLowerCase().trim() === values.questionType.toLowerCase().trim()
				);
				if (duplicateType) {
					form.setFields([
						{
							name: "questionType",
							errors: ["This question type already exists"],
						},
					]);
					return;
				}
				const reqBody = {
					name: values.questionType,
					weightage: values.weightage,
				};
				dispatch(questionTypeAndWeightageCreate(reqBody as createQuestionTypeAndWeightageType));
			} catch (errorInfo) {
				console.log("Validation Failed:", errorInfo);
			}
			break;
		case "update":
			try {
				dispatch(clearUpdateQueTypeAndWeightage());
				const values = await form.validateFields();
				const duplicateType = typeAndWeightage
					.filter(
						(item: any) => item.name.toLowerCase().trim() !== props.state.updateQuestionType.toLowerCase().trim()
					)
					.some((item) => item.name.toLowerCase().trim() === values.questionType.toLowerCase().trim());
				if (duplicateType) {
					form.setFields([
						{
							name: "questionType",
							errors: ["This question type already exists"],
						},
					]);
					return;
				}
				const reqBody = {
					id: props.state.updateId,
					obj: { name: values.questionType, weightage: values.weightage },
				};
				props.onClose();
				dispatch(updateQueTypeAndWeightage(reqBody as updateQuestionTypeAndWeightageType));
			} catch (errorInfo) {
				console.log("Validation Failed:", errorInfo);
			}
			break;

		default:
			break;
		}
	};
	const [form] = Form.useForm();

	useEffect(() => {
		if (!props.state.isUpdateNewModalOpen) return;
		form.setFieldsValue({
			weightage: props.state.updateWeightage,
			questionType: props.state.updateQuestionType,
		});
		setWeightage(String(props.state.updateWeightage ?? ""));
	}, [props.state.updateQuestionType, props.state.updateWeightage]);

	return (
		<Modal
			className="settings_modal"
			open={props.state.isUpdateNewModalOpen || props.state.isAddNewModalOpen}
			title={`${props.modalType == "add" ? "Add Question Type" : "Edit Question Type"}`}
			okText={props.modalType == "add" ? "Add" : "Save"}
			cancelText="Close"
			closable={false}
			onCancel={props.onClose}
			onOk={handleOk}
		>
			<div className="settings_add_modal_container">
				<Form
					form={form}
					layout="vertical"
					name="form_in_modal"
					initialValues={{ modifier: "public" }}
					className="modal-form px-2"
				>
					<Form.Item
						name="questionType"
						label="Question Type"
						rules={[{ required: true, message: "Please input the question type" }]}
					>
						<Input maxLength={40} className="custom_ant_input" />
					</Form.Item>
					<Form.Item
						name="weightage"
						label="Weightage"
						rules={[{ required: true, message: "Please input the weightage" }]}
						normalize={(value) => {
							if (!value) return value;
							const numericValue = value.replace(/\D/g, "");
							return numericValue.slice(0, 2);
						}}
					>
						<Input className="custom_ant_input" />
					</Form.Item>
				</Form>
			</div>
		</Modal>
	);
};
